import { Injectable } from '@angular/core';
import { ApiService } from '@core/api/api.service';
import { CurrentUser, UserPreferences } from '@shared/interfaces';
import { ApiHelper } from '@core/api/api.helper';
import { UserPreferenceKeysEnum, UserRoleEnum } from '@shared/enums';
import { forkJoin } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UserApi {
    constructor(private apiService: ApiService) {}

    private readonly resourceUrl: string = `users`;

    getCurrentUserDetails(): Promise<{ user: CurrentUser; preferences: UserPreferences }> {
        const sources = [
            this.apiService.get(`${this.resourceUrl}/current-user-details`),
            this.apiService.get(`user-preferences`),
        ];

        return new Promise<{ user: CurrentUser; preferences: UserPreferences }>(resolve => {
            forkJoin(sources).subscribe({
                next: (response: any) => {
                    resolve({
                        user: {
                            id: response[0].userId,
                            firstName: response[0].firstName,
                            lastName: response[0].lastName,
                            shortName:
                                response[0].firstName +
                                ' ' +
                                (response[0].lastName ? response[0].lastName[0] + '.' : ''),
                            role: response[0].isAdmin ? UserRoleEnum.ADMIN : UserRoleEnum.USER,
                            email: response[0].email,
                            laboratoryId: response[0].laboratoryId,
                            laboratoryName: response[0].laboratoryName,
                            hasCentralShippingAdminRole: response[0].hasCentralShippingAdminRole,
                        },
                        preferences: {
                            userId: response[1].userId,
                            preferences: (response[1].userPreferences || []).map((preference: any) => {
                                return {
                                    key: preference.key,
                                    value: preference.value,
                                };
                            }),
                        },
                    });
                },
                error: err => {
                    ApiHelper.resolveError(resolve, '');
                    console.error(err);
                },
            });
        });
    }

    saveUserPreferences(userPreference: { key: UserPreferenceKeysEnum; value: string }): Promise<null> {
        return new Promise<null>(resolve => {
            this.apiService.post(`user-preferences/save`, userPreference).subscribe({
                next: () => {
                    resolve(null);
                },
                error: err => {
                    ApiHelper.resolveError(resolve, '');
                    console.error(err);
                },
            });
        });
    }
}
